module.exports = __webpack_public_path__ + "static/media/eve.768ed692.svg";